module.exports = __webpack_public_path__ + "img/map-placeholder-south-small.f7baae01.png";